const STORE_NAME_SPACE = 'ecal-world';

export function getLocalSettings() {
    const now = new Date().getTime();
    const infoJson = localStorage.getItem(STORE_NAME_SPACE);
    if (!infoJson) {
        const info = { updated: now, user: {}, page: {} };
        localStorage.setItem(STORE_NAME_SPACE, JSON.stringify(info));
        return info;
    }
    return JSON.parse(infoJson);
}

export function setLocalSettings(info) {
    info.updated = new Date().getTime();
    localStorage.setItem(STORE_NAME_SPACE, JSON.stringify(info));
}

export function setAuthSession(settings) {
    const key = `${STORE_NAME_SPACE}_AUTH`;
    const session = getAuthSession();
    const authSettings = { ...session, ...settings, date_modified: new Date().getTime() };
    localStorage.setItem(key, JSON.stringify(authSettings));
}

export function getAuthSession() {
    const key = `${STORE_NAME_SPACE}_AUTH`;
    const settingsJson = localStorage.getItem(key);
    if (!settingsJson) {
        const settings = { date_modified: new Date().getTime() };
        localStorage.setItem(key, JSON.stringify(settings));
        return settings;
    }
    return JSON.parse(settingsJson);
}

export function clearAuthSession() {
    const key = `${STORE_NAME_SPACE}_AUTH`;
    localStorage.setItem(key, JSON.stringify({}));
}
